"use strict";

var _mithril = require("mithril");

var _mithril2 = _interopRequireDefault(_mithril);

var _tagl = require("tagl");

var _tagl2 = _interopRequireDefault(_tagl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var camelToHyphen = function camelToHyphen(s) {
  return s.replace(/([A-Z])/g, function (g) {
    return "-" + g[0].toLowerCase();
  });
};

var tagl_hyperscript = function tagl_hyperscript() {
  return (0, _tagl2.default)(function (tagName, classes) {
    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }

    var cls = classes.map(camelToHyphen).join(".");
    var fullTagName = cls.length ? [tagName, cls].join(".").replace(".$", "#") : tagName;
    return _mithril2.default.apply(undefined, [fullTagName].concat(args));
  });
};

if (true) {
  module.exports = tagl_hyperscript;
} else {
  module.exports.tagl = tagl_hyperscript;
  module.exports.a = tagl_hyperscript();
  module.exports.abbr = tagl_hyperscript();
  module.exports.acronym = tagl_hyperscript();
  module.exports.address = tagl_hyperscript();
  module.exports.applet = tagl_hyperscript();
  module.exports.area = tagl_hyperscript();
  module.exports.article = tagl_hyperscript();
  module.exports.aside = tagl_hyperscript();
  module.exports.audio = tagl_hyperscript();
  module.exports.b = tagl_hyperscript();
  module.exports.base = tagl_hyperscript();
  module.exports.basefont = tagl_hyperscript();
  module.exports.bdi = tagl_hyperscript();
  module.exports.bdo = tagl_hyperscript();
  module.exports.big = tagl_hyperscript();
  module.exports.blockquote = tagl_hyperscript();
  module.exports.body = tagl_hyperscript();
  module.exports.br = tagl_hyperscript();
  module.exports.button = tagl_hyperscript();
  module.exports.canvas = tagl_hyperscript();
  module.exports.caption = tagl_hyperscript();
  module.exports.center = tagl_hyperscript();
  module.exports.cite = tagl_hyperscript();
  module.exports.code = tagl_hyperscript();
  module.exports.col = tagl_hyperscript();
  module.exports.colgroup = tagl_hyperscript();
  module.exports.datalist = tagl_hyperscript();
  module.exports.dd = tagl_hyperscript();
  module.exports.del = tagl_hyperscript();
  module.exports.details = tagl_hyperscript();
  module.exports.dfn = tagl_hyperscript();
  module.exports.dir = tagl_hyperscript();
  module.exports.div = tagl_hyperscript();
  module.exports.dl = tagl_hyperscript();
  module.exports.dt = tagl_hyperscript();
  module.exports.em = tagl_hyperscript();
  module.exports.embed = tagl_hyperscript();
  module.exports.fieldset = tagl_hyperscript();
  module.exports.figcaption = tagl_hyperscript();
  module.exports.figure = tagl_hyperscript();
  module.exports.font = tagl_hyperscript();
  module.exports.footer = tagl_hyperscript();
  module.exports.form = tagl_hyperscript();
  module.exports.frame = tagl_hyperscript();
  module.exports.frameset = tagl_hyperscript();
  module.exports.h1 = tagl_hyperscript();
  module.exports.h2 = tagl_hyperscript();
  module.exports.h3 = tagl_hyperscript();
  module.exports.h4 = tagl_hyperscript();
  module.exports.h5 = tagl_hyperscript();
  module.exports.h6 = tagl_hyperscript();
  module.exports.head = tagl_hyperscript();
  module.exports.header = tagl_hyperscript();
  module.exports.hgroup = tagl_hyperscript();
  module.exports.hr = tagl_hyperscript();
  module.exports.html = tagl_hyperscript();
  module.exports.i = tagl_hyperscript();
  module.exports.iframe = tagl_hyperscript();
  module.exports.img = tagl_hyperscript();
  module.exports.input = tagl_hyperscript();
  module.exports.ins = tagl_hyperscript();
  module.exports.kbd = tagl_hyperscript();
  module.exports.keygen = tagl_hyperscript();
  module.exports.label = tagl_hyperscript();
  module.exports.legend = tagl_hyperscript();
  module.exports.li = tagl_hyperscript();
  module.exports.link = tagl_hyperscript();
  module.exports.map = tagl_hyperscript();
  module.exports.mark = tagl_hyperscript();
  module.exports.menu = tagl_hyperscript();
  module.exports.meta = tagl_hyperscript();
  module.exports.meter = tagl_hyperscript();
  module.exports.nav = tagl_hyperscript();
  module.exports.noframes = tagl_hyperscript();
  module.exports.noscript = tagl_hyperscript();
  module.exports.object = tagl_hyperscript();
  module.exports.ol = tagl_hyperscript();
  module.exports.optgroup = tagl_hyperscript();
  module.exports.option = tagl_hyperscript();
  module.exports.output = tagl_hyperscript();
  module.exports.p = tagl_hyperscript();
  module.exports.param = tagl_hyperscript();
  module.exports.pre = tagl_hyperscript();
  module.exports.progress = tagl_hyperscript();
  module.exports.q = tagl_hyperscript();
  module.exports.rp = tagl_hyperscript();
  module.exports.rt = tagl_hyperscript();
  module.exports.ruby = tagl_hyperscript();
  module.exports.s = tagl_hyperscript();
  module.exports.samp = tagl_hyperscript();
  module.exports.script = tagl_hyperscript();
  module.exports.section = tagl_hyperscript();
  module.exports.select = tagl_hyperscript();
  module.exports.small = tagl_hyperscript();
  module.exports.source = tagl_hyperscript();
  module.exports.span = tagl_hyperscript();
  module.exports.strike = tagl_hyperscript();
  module.exports.strong = tagl_hyperscript();
  module.exports.style = tagl_hyperscript();
  module.exports.sub = tagl_hyperscript();
  module.exports.summary = tagl_hyperscript();
  module.exports.sup = tagl_hyperscript();
  module.exports.table = tagl_hyperscript();
  module.exports.tbody = tagl_hyperscript();
  module.exports.td = tagl_hyperscript();
  module.exports.textarea = tagl_hyperscript();
  module.exports.tfoot = tagl_hyperscript();
  module.exports.th = tagl_hyperscript();
  module.exports.thead = tagl_hyperscript();
  module.exports.time = tagl_hyperscript();
  module.exports.tr = tagl_hyperscript();
  module.exports.track = tagl_hyperscript();
  module.exports.tt = tagl_hyperscript();
  module.exports.u = tagl_hyperscript();
  module.exports.ul = tagl_hyperscript();
  module.exports.var_ = tagl_hyperscript();
  module.exports.video = tagl_hyperscript();
  module.exports.wbr = tagl_hyperscript();
  module.exports.animate = tagl_hyperscript();
  module.exports.animateMotion = tagl_hyperscript();
  module.exports.animateTransform = tagl_hyperscript();
  module.exports.circle = tagl_hyperscript();
  module.exports.clipPath = tagl_hyperscript();
  module.exports.colorProfile = tagl_hyperscript();
  module.exports.defs = tagl_hyperscript();
  module.exports.desc = tagl_hyperscript();
  module.exports.discard = tagl_hyperscript();
  module.exports.ellipse = tagl_hyperscript();
  module.exports.feBlend = tagl_hyperscript();
  module.exports.feColorMatrix = tagl_hyperscript();
  module.exports.feComponentTransfer = tagl_hyperscript();
  module.exports.feComposite = tagl_hyperscript();
  module.exports.feConvolveMatrix = tagl_hyperscript();
  module.exports.feDiffuseLighting = tagl_hyperscript();
  module.exports.feDisplacementMap = tagl_hyperscript();
  module.exports.feDistantLight = tagl_hyperscript();
  module.exports.feDropShadow = tagl_hyperscript();
  module.exports.feFlood = tagl_hyperscript();
  module.exports.feFuncA = tagl_hyperscript();
  module.exports.feFuncB = tagl_hyperscript();
  module.exports.feFuncG = tagl_hyperscript();
  module.exports.feFuncR = tagl_hyperscript();
  module.exports.feGaussianBlur = tagl_hyperscript();
  module.exports.feImage = tagl_hyperscript();
  module.exports.feMerge = tagl_hyperscript();
  module.exports.feMergeNode = tagl_hyperscript();
  module.exports.feMorphology = tagl_hyperscript();
  module.exports.feOffset = tagl_hyperscript();
  module.exports.fePointLight = tagl_hyperscript();
  module.exports.feSpecularLighting = tagl_hyperscript();
  module.exports.feSpotLight = tagl_hyperscript();
  module.exports.feTile = tagl_hyperscript();
  module.exports.feTurbulence = tagl_hyperscript();
  module.exports.filter = tagl_hyperscript();
  module.exports.foreignObject = tagl_hyperscript();
  module.exports.g = tagl_hyperscript();
  module.exports.hatch = tagl_hyperscript();
  module.exports.hatchpath = tagl_hyperscript();
  module.exports.image = tagl_hyperscript();
  module.exports.line = tagl_hyperscript();
  module.exports.linearGradient = tagl_hyperscript();
  module.exports.marker = tagl_hyperscript();
  module.exports.mask = tagl_hyperscript();
  module.exports.mesh = tagl_hyperscript();
  module.exports.meshgradient = tagl_hyperscript();
  module.exports.meshpatch = tagl_hyperscript();
  module.exports.meshrow = tagl_hyperscript();
  module.exports.metadata = tagl_hyperscript();
  module.exports.mpath = tagl_hyperscript();
  module.exports.path = tagl_hyperscript();
  module.exports.pattern = tagl_hyperscript();
  module.exports.polygon = tagl_hyperscript();
  module.exports.polyline = tagl_hyperscript();
  module.exports.radialGradient = tagl_hyperscript();
  module.exports.rect = tagl_hyperscript();
  module.exports.set = tagl_hyperscript();
  module.exports.solidcolor = tagl_hyperscript();
  module.exports.stop = tagl_hyperscript();
  module.exports.svg = tagl_hyperscript();
  module.exports.switch_ = tagl_hyperscript();
  module.exports.symbol = tagl_hyperscript();
  module.exports.text = tagl_hyperscript();
  module.exports.textPath = tagl_hyperscript();
  module.exports.tspan = tagl_hyperscript();
  module.exports.unknown = tagl_hyperscript();
  module.exports.use = tagl_hyperscript();
  module.exports.view = tagl_hyperscript();
  module.exports.math = tagl_hyperscript();
  module.exports.maction = tagl_hyperscript();
  module.exports.maligngroup = tagl_hyperscript();
  module.exports.malignmark = tagl_hyperscript();
  module.exports.menclose = tagl_hyperscript();
  module.exports.merror = tagl_hyperscript();
  module.exports.mfenced = tagl_hyperscript();
  module.exports.mfrac = tagl_hyperscript();
  module.exports.mglyph = tagl_hyperscript();
  module.exports.mi = tagl_hyperscript();
  module.exports.mlabeledtr = tagl_hyperscript();
  module.exports.mlongdiv = tagl_hyperscript();
  module.exports.mmultiscripts = tagl_hyperscript();
  module.exports.mn = tagl_hyperscript();
  module.exports.mo = tagl_hyperscript();
  module.exports.mover = tagl_hyperscript();
  module.exports.mpadded = tagl_hyperscript();
  module.exports.mphantom = tagl_hyperscript();
  module.exports.mroot = tagl_hyperscript();
  module.exports.mrow = tagl_hyperscript();
  module.exports.ms = tagl_hyperscript();
  module.exports.mscarries = tagl_hyperscript();
  module.exports.mscarry = tagl_hyperscript();
  module.exports.msgroup = tagl_hyperscript();
  module.exports.msline = tagl_hyperscript();
  module.exports.mspace = tagl_hyperscript();
  module.exports.msqrt = tagl_hyperscript();
  module.exports.msrow = tagl_hyperscript();
  module.exports.mstack = tagl_hyperscript();
  module.exports.mstyle = tagl_hyperscript();
  module.exports.msub = tagl_hyperscript();
  module.exports.msup = tagl_hyperscript();
  module.exports.msubsup = tagl_hyperscript();
  module.exports.mtable = tagl_hyperscript();
  module.exports.mtd = tagl_hyperscript();
  module.exports.mtext = tagl_hyperscript();
  module.exports.mtr = tagl_hyperscript();
  module.exports.munder = tagl_hyperscript();
  module.exports.munderover = tagl_hyperscript();
  module.exports.semantics = tagl_hyperscript();
  module.exports.annotation = tagl_hyperscript();
  module.exports.annotationXml = tagl_hyperscript();
  module.exports.m = _mithril2.default;
}